const configs = {
    login: {
        apiBaseUrl: 'https://login-back.fleetingo.com',
        appName: 'LOG-IN CZ',
        appBackgroundImage: 'bg.login.jpg',
        hereMapsAppId: 'eOySXHT7J9gjixBuBXjH',
        hereMapsAppCode: 'BRm5mfk5cbC-l-TRF3NhOw',
    },
    selectra: {
        apiBaseUrl: 'https://selectra-back.fleetingo.com',
        appName: 'Selectra',
        appBackgroundImage: 'bg.selectra.jpg',
        hereMapsAppId: 'VWDXaic80RD9hxjqX19U',
        hereMapsAppCode: 'nM8cLAxzzevuJTGoxiRPjA',
        notificationsUrl: 'https://selectra-back.fleetingo.com:6003',
    },
    'selectra-transport': {
        apiBaseUrl: 'https://selectra-transport-back.fleetingo.com',
        appName: 'Selectra Transport',
        appBackgroundImage: 'bg.selectra.jpg',
        hereMapsAppId: 'VWDXaic80RD9hxjqX19U',
        hereMapsAppCode: 'nM8cLAxzzevuJTGoxiRPjA',
        notificationsUrl: 'https://selectra-transport-back.fleetingo.com:6003',
    },
    stl: {
        apiBaseUrl: 'https://stl-back.fleetingo.com',
        appName: 'STL Express',
        appBackgroundImage: 'bg.default.jpg',
        hereMapsAppId: 'eOySXHT7J9gjixBuBXjH',
        hereMapsAppCode: 'BRm5mfk5cbC-l-TRF3NhOw',
    },
    jirolsped: {
        apiBaseUrl: 'https://jirolsped-back.fleetingo.com',
        appName: 'JIROL Sped',
        appBackgroundImage: 'bg.default.jpg',
        hereMapsAppId: 'eOySXHT7J9gjixBuBXjH',
        hereMapsAppCode: 'BRm5mfk5cbC-l-TRF3NhOw',
    },
    bmt: {
        apiBaseUrl: 'https://bmt-back.fleetingo.com',
        appName: 'BMT CZ',
        appBackgroundImage: 'bg.default.jpg',
        hereMapsAppId: 'eOySXHT7J9gjixBuBXjH',
        hereMapsAppCode: 'BRm5mfk5cbC-l-TRF3NhOw',
    },
    vrcspeed: {
        apiBaseUrl: 'https://vrcspeed-back.fleetingo.com',
        appName: 'VRC SPEED',
        appBackgroundImage: 'bg.default.jpg',
        hereMapsAppId: 'eOySXHT7J9gjixBuBXjH',
        hereMapsAppCode: 'BRm5mfk5cbC-l-TRF3NhOw',
    },
    demo: {
        apiBaseUrl: 'https://demo-back.fleetingo.com',
        appName: 'DEMO',
        appBackgroundImage: 'bg.default.jpg',
        hereMapsAppId: 'eOySXHT7J9gjixBuBXjH',
        hereMapsAppCode: 'BRm5mfk5cbC-l-TRF3NhOw',
        notificationsUrl: 'https://demo-back.fleetingo.com:6002',
    },
    dev: {
        apiBaseUrl: 'https://dev-back.fleetingo.com',
        appName: 'DEV',
        appBackgroundImage: 'bg.default.jpg',
        hereMapsAppId: 'eOySXHT7J9gjixBuBXjH',
        hereMapsAppCode: 'BRm5mfk5cbC-l-TRF3NhOw',
        notificationsUrl: 'https://dev-back.fleetingo.com:6001',
    },
    azb: {
        apiBaseUrl: 'https://azb-back.fleetingo.com',
        appName: 'A.Z.B.',
        appBackgroundImage: 'bg.default.jpg',
        hereMapsAppId: 'eOySXHT7J9gjixBuBXjH',
        hereMapsAppCode: 'BRm5mfk5cbC-l-TRF3NhOw',
    },
    zayml: {
        apiBaseUrl: 'https://zayml-back.fleetingo.com',
        appName: 'ZAYML SK',
        appBackgroundImage: 'bg.default.jpg',
        hereMapsAppId: 'eOySXHT7J9gjixBuBXjH',
        hereMapsAppCode: 'BRm5mfk5cbC-l-TRF3NhOw',
    },
    hubert: {
        apiBaseUrl: 'https://hubert-back.fleetingo.com',
        appName: 'HUBERT',
        appBackgroundImage: 'bg.default.jpg',
        hereMapsAppId: 'eOySXHT7J9gjixBuBXjH',
        hereMapsAppCode: 'BRm5mfk5cbC-l-TRF3NhOw',
    },
    bb: {
        apiBaseUrl: 'https://bb-back.fleetingo.com',
        appName: 'B&Bartoni',
        appBackgroundImage: 'bg.default.jpg',
        hereMapsAppId: 'eOySXHT7J9gjixBuBXjH',
        hereMapsAppCode: 'BRm5mfk5cbC-l-TRF3NhOw',
    },
    mwl: {
        apiBaseUrl: 'https://mwl-back.fleetingo.com',
        appName: 'Maurice Ward Logistics',
        appBackgroundImage: 'bg.default.jpg',
        hereMapsAppId: 'eOySXHT7J9gjixBuBXjH',
        hereMapsAppCode: 'BRm5mfk5cbC-l-TRF3NhOw',
    },
    sebalex: {
        apiBaseUrl: 'https://sebalex-back.fleetingo.com',
        appName: 'Sebalex',
        appBackgroundImage: 'bg.default.jpg',
        hereMapsAppId: 'eOySXHT7J9gjixBuBXjH',
        hereMapsAppCode: 'BRm5mfk5cbC-l-TRF3NhOw',
    },
    pame: {
        apiBaseUrl: 'https://pame-back.fleetingo.com',
        appName: 'PAME',
        appBackgroundImage: 'bg.default.jpg',
        hereMapsAppId: 'eOySXHT7J9gjixBuBXjH',
        hereMapsAppCode: 'BRm5mfk5cbC-l-TRF3NhOw',
    },
    default: {
        apiBaseUrl: 'http://fleetingo-backend.test',
        appName: 'Demo',
        appBackgroundImage: 'bg.default.jpg',
        hereMapsAppId: 'eOySXHT7J9gjixBuBXjH',
        hereMapsAppCode: 'BRm5mfk5cbC-l-TRF3NhOw',
    },
}

const subdomain = window && window.location && window.location.host.split('.')[0]
const config = configs[subdomain] || configs.default

export const CFG_SUBDOMAIN = subdomain
export const CFG_API_BASE_URL = config.apiBaseUrl

export const CFG_APP_NAME = config.appName
export const CFG_APP_BACKGROUND_IMAGE = config.appBackgroundImage

export const CFG_HERE_MAPS_APP_ID = config.hereMapsAppId
export const CFG_HERE_MAPS_APP_CODE = config.hereMapsAppCode

export const CFG_GOOGLE_API_KEY = 'AIzaSyBwogBHWqId4gPaF5Mw92ckzFkcvz2k4bs'

export const CFG_VERSION = '1.0'

export const NOTIFICATIONS_URL = config.notificationsUrl
